import React, { useEffect } from "react";
import swal from "sweetalert";
import { useQuery } from "seed/gql";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/studio/rightnav/versions/VersionList.view";


function VersionList({ flow, placeholder }) {

  const usertId = sessionStorage.getItem("id");

  const [callSetCurrentVersion, reqSetCurrentVersion] = usePost("/flows/set_current_version", {
    onCompleted: (data) => {
      const flowId = data?.flow_id;
      window.location.href = `/app/studio/${flowId}/flow`;
    },
    onError: (error) => {
      console.error("Error setting active version:", error);
      swal("Error", l("No se pudo restaurar la versión, por favor vuelva a intentar mas tarde%SA176"), "error");
    }
  })

  const reqFlowVersions = useQuery(`{
    flows {
      versionDate
      versionSettings
      isReleaseVersion
      currentFlow {
        id
      }
    }  
  }`, `user.id=${usertId} AND is_current_version=False AND current_flow.id=${flow.id} AND is_active=true`, {
    "orderBy": "-version_date",
  });

  useEffect(() => {
    reqFlowVersions.refetch();
  }, []);

  const onClickRestoreVersion = (flowVersionId) => {
    swal({
      title: l("¿Restaurar versión?%SA177"),
      text: l("¿Está seguro de que desea restaurar esta versión?%SA178"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willRestore) => {
        if (willRestore) {
          callSetCurrentVersion({
            flow_id: flow.id,
            flow_version_id: flowVersionId
          });
        }
      });
  }


  if (reqFlowVersions.loading) return <Loading />;
  if (reqFlowVersions.error) return "Error";

  const { flows = [] } = reqFlowVersions.data;

  return (
    <View
      flows={flows}
      placeholder={placeholder}
      onClickRestoreVersion={onClickRestoreVersion}
    />
  );
}


export default VersionList;